import { useMutation } from '@tanstack/react-query';

import { axios } from '@/src/lib/axios/axios';
import { generateRoutePath } from '@/src/routes';

import { QUICKBOOKS_BASE_URL } from '.';

import { TreatmentType, Treatment } from '../types/treatment';

type UpdateDraftParams = {
  documentId: number;
  draftId: number;
  params: {
    type?: TreatmentType;
    transaction: Treatment['payload'];
  };
};

type UpdateTreatmentResponse = {
  draftId: number;
};

const updateDraft = ({
  documentId,
  draftId,
  params,
}: UpdateDraftParams): Promise<UpdateTreatmentResponse> => {
  const url = generateRoutePath(`${QUICKBOOKS_BASE_URL}/:documentId/drafts/:draftId`, {
    documentId,
    draftId,
  });

  return axios.put(url, params);
};

export const useUpdateDraft = () => {
  return useMutation({
    mutationFn: (mutationsParams: UpdateDraftParams) => updateDraft(mutationsParams),
  });
};
